// =============================================================================
//  Copyright : 2024 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : manage transcriber account
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {get} from 'ldash'
import {Actions, Sel} from 'uix/registries'

import log from 'uix/logging'
import {Link} from 'uix/components'
import {useApi, useState, useResettableState, useCallApi, useRouter} from 'uix/hooks'

// ---Local imports
import {TranscriptionLayout} from '../components'
import {useApiWithPuid} from '../hooks'

// ---Globals

// ---Exports
const TranscriberAccountState = ({i18n, transcriber}) => {
  let {go} = useRouter()
  let [selectedOption, setSelectedOption] = useState(null)

  let handleOptionChange = event => {
    setSelectedOption(event.target.value)
  }

  let [changedName, setChangedName] = useResettableState('', [selectedOption])
  let changeName = value => (
    <div>
      <input type="text" value={value} onChange={e => setChangedName(e.target.value)} />
    </div>
  )

  let {callApi} = useCallApi('setTranscriberAuthorship')
  let submitChange = () => {
    let visible = selectedOption == 'transcriberChangeToName'
    callApi({puid: transcriber.puid, name: changedName, visible}, data => {
      if (data?.status == 'ok') {
        go({updateQuery: {sent: ''}})
      }
    })
  }
  let choice = name => (
    <label>
      <input
        type="radio"
        value={name}
        checked={selectedOption === name}
        onChange={handleOptionChange}
      />
      {i18n.span(name)}
    </label>
  )

  let anonymous = transcriber.visible === false
  return (
    <div>
      {anonymous ? (
        <>
          {choice('transcriberChangeToName')}
          <br />
          {choice('transcriberChangeToAnonymousAnywhere')}
        </>
      ) : (
        choice('transcriberNewToAnonymous')
      )}
      <br />
      {selectedOption == 'transcriberChangeToName' && (
        <>
          <div>{i18n.span('transcriberExplainClearname')}</div>
          <div>{i18n.span('transcriberInsertName')}</div>
          {changeName(changedName || transcriber.fullname)}
        </>
      )}
      {['transcriberChangeToAnonymousAnywhere', 'transcriberNewToAnonymous'].includes(
        selectedOption
      ) && (
        <>
          <div>{i18n.span('transcriberExplainPseudonym')}</div>
          <div>
            {i18n.span('transcriberInsertNick')}
            {changeName(changedName)}
          </div>
        </>
      )}
      {selectedOption && (
        <>
          <button onClick={submitChange}>{i18n.get('transcriberSubmitChange')}</button>{' '}
          <button
            onClick={() => {
              setSelectedOption(null)
            }}
          >
            {i18n.get('transcriberBack')}
          </button>
        </>
      )}
    </div>
  )
}
export const TranscriptionAccount = ({i18n, request}) => {
  // pass through explicit PU_ID

  let sent = request.sent !== undefined

  let {data} = useApiWithPuid(
    'filter/getTranscriberAccount',
    {},
    {
      autoreset: false,
      deps: [sent],
    }
  )
  let transcriber = data?.transcriber || {}

  let anonymous = transcriber.visible === false

  return (
    <TranscriptionLayout>
      <h1>{i18n.span(`transcriberAccountSettings`)}</h1>
      <div className="accountSettings">
        {sent && (
          <>
            <h2 class="subsec">Ihr Status wurde geändert</h2>
            <div> Und ihre Angaben wurden registriert. </div>
          </>
        )}
        <h2 className="subsec">{i18n.span('transcriberAccountStatus')}</h2>
        <div>
          <div className="cell key">{i18n.span('transcriberAccountEmail')}</div>
          <div className="cell">{transcriber.email}</div>
        </div>
        <div>
          <div className="cell key">{i18n.span('__transcriberAccountName')}</div>
          <div className="cell">{transcriber.fullname}</div>
        </div>
      </div>
      <div>
        <div className="cell key">{i18n.span('transcriberAccountCredits')}</div>
        <div className="cell">
          {i18n.span(anonymous ? 'transcriberPerAnonymous' : 'transcriberPerName')}
        </div>
      </div>
      <h2 className="subsec">{i18n.span('transcriberChangeState')}</h2>
      {sent ? (
        <Link query={{}}>{i18n.span('transcriberChangeNew')}</Link>
      ) : (
        <TranscriberAccountState transcriber={transcriber} i18n={i18n} />
      )}
    </TranscriptionLayout>
  )
}
